import {Pais} from './pais';
import {Estado} from './estado';
import {TipoUsuario} from './tipo-usuario';
import {Genero} from './genero';
import {CondicionIva} from './condicion-iva';
import {ListaPrecioCliente} from './lista-precio-cliente';
import {Localidad} from "./localidad";

export class Usuario {
  public id_usuario: number;
  public nombre: string;
  public apellido: string;
  public mail: string;
  public contrasenia: string;
  public dni: string;
  public pais: Pais;
  public codigo_postal: string;
  public terminosCondiciones: boolean;
  public telefono: string;
  public domicilio: string;
  public numero: string;
  public piso: string;
  public dpto: string;
  public fecha_registro: string;
  public estado: Estado;
  public codigo_registro:string;
  public tipousuario:TipoUsuario;
  public genero:Genero;
  public cuit:string;
  public cli_codigo:string;
  public condicioniva:CondicionIva;
  public listapreciocliente:ListaPrecioCliente;
  public camContrasenia:boolean;
  public localidad:Localidad;
  public nombre_fiscal:string;


  constructor(idUsuario: number, nombre: string, apellido: string, mail: string, contrasenia: string, pais: Pais,
               codigo_postal: string, terminosCondiciones: boolean,telefono:string,dni:string, localidad:Localidad) {
    this.id_usuario = idUsuario;
    this.nombre = nombre;
    this.apellido = apellido;
    this.mail = mail;
    this.contrasenia = contrasenia;
    this.pais = pais;
    this.codigo_postal = codigo_postal;
    this.terminosCondiciones = terminosCondiciones;
    this.telefono = telefono;
    this.dni=dni;
    this.localidad=localidad;
  }
}
